import type { Product, SortOption } from "./types";

export function filterProducts(items: Product[], selectedCategory: string, selectedMaxOverall: number): Product[] {
  return items.filter((item) => {
    const categoryMatch = selectedCategory === "Alle" || item.category === selectedCategory;
    const overallMatch = item.overall <= selectedMaxOverall;
    return categoryMatch && overallMatch;
  });
}

export function sortProducts(items: Product[], sortBy: SortOption): Product[] {
  const sorted = [...items];

  switch (sortBy) {
    case "overall-asc":
      sorted.sort((a, b) => a.overall - b.overall);
      break;
    case "overall-desc":
      sorted.sort((a, b) => b.overall - a.overall);
      break;
    case "price-asc":
      sorted.sort((a, b) => a.price - b.price);
      break;
    case "price-desc":
      sorted.sort((a, b) => b.price - a.price);
      break;
    default:
      break;
  }

  return sorted;
}
